import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=6c0563ad&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"
import style0 from "./Import.vue?vue&type=style&index=0&id=6c0563ad&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0563ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0563ad')) {
      api.createRecord('6c0563ad', component.options)
    } else {
      api.reload('6c0563ad', component.options)
    }
    module.hot.accept("./Import.vue?vue&type=template&id=6c0563ad&scoped=true", function () {
      api.rerender('6c0563ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/Import.vue"
export default component.exports